function EnrolleesData() {
    "use strict";

    this.TargetId = -1;

    this.AddressEditItem = {};
    this.MaximumZoneRadius = 402; // one quarter mile in meters
    this.RequestId = -1;
    this.OffenderMapRequestCount = 0;

    this.DistancePoints = [];
    this.DistanceToolActive = false;

    this.CardView = null;
    this.IsCardviewInitialized = false;
    this.IsSecondaryVisible = true;
    //this.OffenderTrackpoints = 0;
    this.OffenderCurrentId = -1;
    this.OffenderEditingId = -1;
    this.OffenderEidReservation = null;

    this.OffenderClean = null;
    this.OffenderSort = null;
    this.OffenderDirty = null;
    this.OffenderPaginated = null;
    this.OffenderEvents = null;
    this.OffenderEventsSorted = null;
    this.OffenderEventsRendered = null;
    this.OffenderEnrollment = null;
    this.StationDeviceTypeWizard = null;
    this.OffenderDeviceClusters = null;
    this.OffenderDeviceAddOns = null;
    this.OffenderProfileCurrent = null;
    this.OffenderProfileCategories = [];
    this.OffenderProfileSexOffenses = [];
    this.OffenderProfileAddresses = [];
    this.OffenderZoneEdit = null;
    this.OffenderZoneShapeEdit = null;
    this.OffenderVisitTagId = -1;
    this.OffenderTimeZoneIsOverridden = true;
    this.OffenderScheduleConfiguration = null;
    this.Validator = null;
    this.VictimEnrollment = null;
    this.VictimAssignableOffenders - null;

    this.TagCardClean = null;
    this.OffenderMapCardClean = null;
    this.OffenderMapCardDirty = null;
    this.OffenderMapCardRendered = null;
    this.TagOverlayClean = null;
    this.OffenderMapOverlayClean = null;
    this.OffenderMapOverlayDirty = null;
    this.OffenderCaseLoad = null;
    this.IsOffenderMapFit = false;

    this.OffenderSecondaryCurrentId = null;
    this.OffenderSecondaryClean = null;
    this.OffenderSecondaryDirty = null;
    this.OffenderSecondaryPaginated = null;

    this.OffenderSecondaryMapCardClean = null;
    this.OffenderSecondaryMapCardDirty = null;
    this.OffenderSecondaryMapCardPaginated = null;

    this.OffenderSecondaryMapOverlayClean = null;
    this.OffenderSecondaryMapOverlayDirty = null;

    this.OffenderMerged = null;
    this.OffenderMergedPaginated = null;

    this.StationsClean = null;
    this.StationEnrollees = null;
    this.AddOnsAvailable = false;
    this.AddOnsClean = null;
    this.EnrolleeZoneIdList = [];
    this.SchedulesZonesClean = null;
    this.SchedulesAddressesClean = null;
    this.SchedulesTargetsClean = null;
    this.SchedulesEditItem = new OffenderSchedule();
    this.SchedulesValidator = null;

    this.VictimCurrentId = -1;
    this.VictimSecondaryCurrentId = -1;
    this.VictimEditingId = -1;
    this.VictimClean = null;
    this.VictimDirty = null;
    this.VictimPaginated = null;
    this.VictimSort = null;
    this.VictimProfileCurrent = null;
    this.VictimTempId = -1;
    this.VictimNotifications = [];

    this.PlaybackStatus = 'Stopped';
    this.PlaybackDirection = 1;
    this.PlaybackDivider = 1;
    this.MapRenderState = new MapSettingState();

    this.EventsPaginated = null;

    this.MapEndDate = new Date();
    this.TargetZoneId = -1;

    this.LastLocationByCardView = null;
    this.OffenderPastData = [];
    this.VisitsProcesssed = false;

    // map counters
    this.VisitPointCount = 0;
    this.TrackPointCount = 0;
    this.CellTowerPointCount = 0;
    this.AnalysisEnrollee = -1;

    //time zone
    this.EnrolleesTimeZone = null;

    // needed for user story 1089
    this.EnrolleeChangeReasonHolder = [];

    // patch 2.5.2 lock feature
    this.LockFeatureEndSaveState = null;
    this.LockFeatureStartSaveState = null;
    this.LockedOffender = null;
    // patch 2.5.7 second lock....
    this.secondLockDate = null;
    this.secondLockOnEnrolleeId = null;

    // force refresh
    this.IsEnrolleeCacheClicked = false;
    this.IsEnrolleeCacheUpdateAvailable = false;

    this.IsExpandedAllVisits = false;

    this.GpsCount = -1;

    // user story 2077
    this.EnrolleeAddressGeocodeMatch = null;

    this.EnrolleeRecentlyUpdated = [];

    // schedules date display
    this.EnrolleesSchedulesSorted = null;
    this.EnrolleesSchedulesPaginated = null;

    //multiple photos
    this.OffenderPhotos = [];
    this.OffenderPhotoIndex = 0;
    this.OffenderPhotoDescription = '';
    this.OffenderPhotosAdded = [];
    this.OffenderPhotosEdited = [];
    this.OffenderPhotosDeleted = [];
    this.OffenderPhotosEditMode = 'Display';


    // charting dates
    this.ChartStartDate = null;
    this.ChartEndDate = null;
    this.ChartingEnrolleeId = -1;
    this.CurrentTimelineEvent = null;
    this.TimelinePopupOption = 'Default';
    //BluPlusConfiguration
    this.BluPlusConfiguration = null;

    //frp
    this.OffenderFrp = [];
    //holds frps for dropdown field
    this.Frps = [];
    this.CurrentOffenderFrpId = -1;
    this.QueuedFrps = [];

    this.DefaultView = 'Cards';

    //heatmap
    this.HeatMapStartDate = null
    this.HeatMapEndDate = null;
    this.HeatMapStartTime = null;
    this.HeatMapEndTime = null;
    this.OffenderHeatMapAddOnSelected = [];
    this.OffenderHeatMapSelected = [];
    this.sobertracksResults = [];

    //SoberTrack
    this.CurrentAlcoholImage = null;   
    this.CurrentAlcoholImages = [];
    this.CurrentAlcoholSchedule = null;
    this.CurrentAlcoholResult = null;
    this.SoberTrackResultsDirty = [];
    this.OffenderPhotosAlcohol = [];
    this.OffenderPhotoIndexAlcohol = 0;
    this.OffenderPhotoDescriptionAlcohol = '';
    this.OffenderPhotosAddedAlcohol = [];
    this.OffenderPhotosEditedAlcohol = [];
    this.OffenderPhotosDeletedAlcohol = [];
    this.OffenderAlcoholScheduleNoteContent = null;
    this.AlcoholNotesManager = null;
    this.AlcoholNotesList = null;
    this.SoberTrackReviewListSorted = null;
    this.SoberTrackAssigned = false;
    this.SoberTrackAssignedPreviously = false;
    this.SoberTrackBlockDelete = [];
    this.OffenderAlcoholSchedSTDWarning = false;
    this.OffenderAlcoholSchedWarningData = null;
    this.OffenderAlcoholSchedSTDPreWarning = false;

    //CarveOut
    this.CarveOutDelete = [];
    this.ScheduleToggleSelected = false;
    this.CarveOutTargetsClean = null;
    this.CarveOutScheduleTargetListView = null;

    this.OffenderSchedules = [];

    //latest Week Association
    this.EnrolleeLatestWeekAssociation = [];
    this.EnrolleeLatestWeekAssociationSelected = null;
    //Enrolee blu+ last track before sleep
    this.EnrolleeBPLTBS = null;

    //Enrollee Map Time for Agent Time Management
    this.AgentTimeManagement = [];

    //EMA 
    //this.Questions = [{ Question: 'Any new tattoos?', AllowExtraDetails: false }, { Question: 'Employment status?', AllowExtraDetails: true }, { Question: 'Health status?', AllowExtraDetails: true }, { Question: 'Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question Long Question ', AllowExtraDetails: false }];
    //this.Answers = [['no', 'yes'], ['Still Working at the same job', 'Working at a new job', 'Unemployed', 'unemployed', 'Unempolyed, looking for work', 'Uemployed, Student'], ['okay', 'sick'], ['really long option really long option really long option really long option really long optionreally long option really long option really long option really long option really long option really long option really long option really long option really long option really long option really long option really long option really long option v really long option really long option really long option really long option v really long option really long option really long option really long option really long option really long option really long option really long option', 'end']];
    
    //user map transaction
    this.EnrolleesMapTransactionStartDate = null;
    this.EnrolleesMapTransactionStopDate = null;

    this.EnableInformatics = 0;
    this.EnrolleeAlternateContact = new EnrolleeAlternateContact();
    this.EnrolleeAlternateContacts = [];
    

}
if (typeof exports !== 'undefined') {
    module.exports = EnrolleesData;
}